
import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  tabsLabelContainer: {
    position: 'relative',
  },
  tabsContentContainer: (props) => ({
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'scroll',
    '& > .inner': {
      display: 'flex',
      width: `${props.contentsLength * 100}%`,
      transition: `transform ${theme.speed.normal}ms`,
      willChange: 'transform',
      backfaceVisibility: 'hidden',
    },
  }),
}));

export default useStyle;
